export default "__VITE_ASSET__C0xgKGb2__"